import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectingCableLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85921 38.4465C5.19537 34.7826 5.19537 28.8423 8.85921 25.1785L10.9445 23.0932C11.6707 22.3671 12.8481 22.3671 13.5743 23.0932L24.2124 33.7312C24.9385 34.4575 24.9385 35.6348 24.2124 36.3612L22.1271 38.4465C18.4633 42.1103 12.523 42.1103 8.85921 38.4465Z",
			stroke: "#A8AAE3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85008 38.4486L1.99789 45.3008",
			stroke: "#A8AAE3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.1411 8.16483C35.4772 4.50099 29.5369 4.50099 25.8731 8.16483L23.7878 10.2501C23.0617 10.9763 23.0617 12.1537 23.7878 12.8799L34.426 23.518C35.1521 24.2441 36.3295 24.2441 37.0558 23.518L39.1411 21.4327C42.8049 17.7689 42.8049 11.8287 39.1411 8.16483Z",
			stroke: "currentColor",
			strokeOpacity: .12,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.533 1.83111C46.8259 1.53822 46.8259 1.06334 46.533 0.770451C46.2401 0.477558 45.7653 0.477558 45.4724 0.770451L39.1204 7.12242C39.3088 7.28505 39.4926 7.45576 39.6714 7.63454C39.8493 7.81251 40.0193 7.99544 40.1812 8.18291L46.533 1.83111Z",
			fill: "currentColor",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4341 24.9489L19.5444 20.8387M22.3548 31.8696L26.465 27.7594",
			stroke: "#A8AAE3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgConnectingCableLight;
